import { render, staticRenderFns } from "./ExternalDamageCard.vue?vue&type=template&id=001135b0&scoped=true"
import script from "./ExternalDamageCard.vue?vue&type=script&lang=ts"
export * from "./ExternalDamageCard.vue?vue&type=script&lang=ts"
import style0 from "./ExternalDamageCard.vue?vue&type=style&index=0&id=001135b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001135b0",
  null
  
)

export default component.exports